import React,{ useState } from 'react'
import { Image } from "react-bootstrap";
import styles from './index.module.css'
import { useNavigate } from 'react-router-dom';
import { useSelector } from 'react-redux';
import Menubar from '../Menubar';

export default function Navgater() {
  const {expires}=useSelector((state)=>state.logininfo);
  const navigate=useNavigate();
  const [show,setShow] = useState(false)

  const imgclick = ()=>{
    if(expires>Date.now()){
      setShow(true)
    }else{
      navigate('/login',{replace:true});
    };
  };

  const closeMenubar =()=>{
    setShow(false);
  }

  return (
    <div className={`bg-primary bg-gradient rounded ${styles.Navstye}`}>
      <Image src="./pic/aisudoku.png" alt="logo" width="200" height="50" />
      <Image src="./pic/tiaoweng.png" alt="slet" width="30" height="30"
        style={{cursor: 'pointer'}}
        onClick={imgclick}/>
        {show && <Menubar nu={{closeMenubar}} />}
    </div>
  )
};
